import { defineMessages } from 'react-intl'

export const intlErrorPage = defineMessages({
  backHome: { id: 'error.link.back_home', defaultMessage: 'Return to homepage' },
  notFound: { id: 'error.message.404', defaultMessage: 'Page not found.' },
  messageTitle: { id: 'error.message.title', defaultMessage: 'Oops... this is embarrassing.' },
  messageBaseline: { id: 'error.message.baseline', defaultMessage: 'An error occurred.' },
})
